module.exports = __webpack_public_path__ + "img/icon_jg_act.d93c2e20.png";